var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdIndeterminateCheckBox } from 'react-icons/md';
import { Icon, VisuallyHidden } from "./..";
import { themeLss } from "../../lss";
import styled from "../../styled";
var CheckboxInk = styled.span(themeLss());
var CheckboxInput = styled.input(themeLss());
var Wrapper = styled.label(themeLss());
var focusedState = {
    boxShadow: function (_a) {
        var theme = _a.theme;
        return "0 0 1px 2px " + theme.colors.secondary500;
    }
};
export var Checkbox = function (_a) {
    var _b;
    var checked = _a.checked, defaultChecked = _a.defaultChecked, disabled = _a.disabled, isIndeterminate = _a.isIndeterminate, isInvalid = _a.isInvalid, label = _a.label, lss = _a.lss, props = __rest(_a, ["checked", "defaultChecked", "disabled", "isIndeterminate", "isInvalid", "label", "lss"]);
    var _c = __read(useState(false), 2), isFocused = _c[0], setIsFocused = _c[1];
    var icon = MdCheckBoxOutlineBlank;
    var isChecked = defaultChecked || checked;
    if (isChecked) {
        icon = MdCheckBox;
    }
    else if (isIndeterminate) {
        icon = MdIndeterminateCheckBox;
    }
    return (React.createElement(Wrapper, { onFocus: function () { return setIsFocused(true); }, onBlur: function () { return setIsFocused(false); }, lss: __assign({ display: 'inline-flex', alignItems: 'center', color: isInvalid
                ? 'danger500'
                : isChecked || isIndeterminate
                    ? 'secondary500'
                    : 'inherit', cursor: disabled ? 'not-allowed' : 'default', opacity: disabled ? 'disabled' : 1, ':active': (_b = {},
                _b[CheckboxInput] = {
                    bg: 'opacity'
                },
                _b) }, lss) },
        React.createElement(VisuallyHidden, null,
            React.createElement(CheckboxInput, __assign({ type: "checkbox", disabled: disabled, defaultChecked: defaultChecked, checked: checked }, props))),
        React.createElement(CheckboxInk, { lss: {
                transition: 'fast',
                borderRadius: 'rounded',
                mr: label ? 'sm' : 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(Icon, { as: icon, lss: isFocused ? focusedState : {} })),
        label));
};
//# sourceMappingURL=Checkbox.js.map